import { ApiClient } from '../apiClient';
import { 
  PricingResult as PricingResultType, 
  GetCardsPricingDto, 
  CardsPricingDto, 
} from '../../types/card';

export interface PricingResult {
  price: number;
  currency: string;
  timestamp: number; // Add timestamp for cache invalidation
}

export class PricingService {
  private cache: Map<string, PricingResult> = new Map();
  private readonly CACHE_TTL = 5 * 60 * 1000; // 5 minutes in milliseconds

  constructor(private apiClient: ApiClient) {}

  /**
   * Get pricing directly from a card ID
   */
  async getPricingFromCardId(productId: string, faceValue: number, currency: string, country?: string): Promise<PricingResultType | undefined> {
    try {
      const queryParam = country ? `?country=${country}` : '';
      const response = await this.apiClient.get<PricingResultType>(`/gift/card/${productId}/pricing/${faceValue}/${currency}${queryParam}`);

      // Return the price in the expected format
      return {
        price: response.price,
        price_no_discount: response.price_no_discount,
        discount: response.discount,
      };
    } catch (error) {
      console.error('Error fetching pricing from card ID:', error);
      return { price: faceValue, price_no_discount: faceValue, discount: 0 };
    }
  }

  /**
   * Get pricing for multiple cards with optional coupon support
   */
  async getCardsPricing(query: GetCardsPricingDto): Promise<CardsPricingDto | undefined> {
    const response = await this.apiClient.post<CardsPricingDto>('/gift/cards/pricing', query);
    return response;
  }

  /**
   * Clear the pricing cache
   */
  clearCache(): void {
    this.cache.clear();
  }
}